<div
  *ngIf="separator && separator != ''"
  [innerHTML]="separator | kwikuiSafeHtml"
>
</div>
